module.exports = __webpack_public_path__ + "img/homepage-physio.916ff0bd.jpg";